/**
 * @chineseName Pagination 分页
 * @subDescription m-ui组件 分页
 */
import Pagination from './Pagination';
export default Pagination;